import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export default function LoadingScreen({ onDone }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setVisible(false);
      // give the exit anim a moment, then notify parent
      setTimeout(() => onDone && onDone(), 420);
    }, 1500);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="loading-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0F1F3D]"
        >
          <div className="absolute inset-0 blueprint-grid opacity-60 pointer-events-none" />

          <div className="relative flex flex-col items-center">
            <svg
              width="148"
              height="148"
              viewBox="0 0 148 148"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* outer speedometer arc */}
              <motion.circle
                cx="74"
                cy="74"
                r="64"
                stroke="#E8732C"
                strokeWidth="2"
                fill="none"
                initial={{ pathLength: 0, opacity: 0.7 }}
                animate={{ pathLength: 1, opacity: 1 }}
                transition={{ duration: 1.0, ease: "easeInOut" }}
              />
              {/* tick marks */}
              {Array.from({ length: 12 }).map((_, i) => {
                const angle = (i / 12) * Math.PI * 2 - Math.PI / 2;
                const x1 = 74 + Math.cos(angle) * 56;
                const y1 = 74 + Math.sin(angle) * 56;
                const x2 = 74 + Math.cos(angle) * 50;
                const y2 = 74 + Math.sin(angle) * 50;
                return (
                  <motion.line
                    key={i}
                    x1={x1}
                    y1={y1}
                    x2={x2}
                    y2={y2}
                    stroke="#ffffff"
                    strokeOpacity="0.55"
                    strokeWidth="1.5"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4 + i * 0.03, duration: 0.2 }}
                  />
                );
              })}
              {/* monogram M */}
              <motion.path
                d="M44 100 L44 50 L62 50 L74 78 L86 50 L104 50 L104 100"
                stroke="#ffffff"
                strokeWidth="4"
                strokeLinecap="square"
                strokeLinejoin="miter"
                fill="none"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 1.0, ease: "easeInOut", delay: 0.1 }}
              />
            </svg>

            <div className="mt-8 w-44 h-[3px] bg-white/15 overflow-hidden rounded-full">
              <motion.div
                className="h-full bg-[#E8732C]"
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                transition={{ duration: 1.4, ease: "easeInOut" }}
              />
            </div>

            <motion.p
              className="mt-5 text-[11px] tracking-[0.3em] text-white/60 uppercase font-medium"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.4 }}
            >
              Messinger · Castrop-Rauxel
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
